'use client';

import { HStack, Skeleton, Stack, VStack } from '@chakra-ui/react';

function CartRowSkeleton() {
  return (
    <Stack gap={0}>
      <HStack gap={3} align="center">
        <Skeleton
          minW="48px"
          w="48px"
          h="48px"
          rounded={8}
          flexShrink={0}
        />
        <VStack align="stretch" flex={1} gap={1}>
          <Skeleton h="14px" w="full" maxW="140px" rounded={4} />
          <Skeleton h="12px" w="80px" rounded={4} />
          <Skeleton h="14px" w="50px" rounded={4} />
        </VStack>
        <Skeleton h="32px" w="90px" rounded={8} flexShrink={0} />
      </HStack>
    </Stack>
  );
}

export default function CartProductsSkeleton() {
  return (
    <>
      <HStack justify="space-between" align="center" p={4} pb={2}>
        <Skeleton h="22px" w="60px" rounded={4} />
      </HStack>
      <Stack p={4} pt={0} mt={3} gap={3} h="60vh" overflowY="hidden">
        <CartRowSkeleton />
        <CartRowSkeleton />
        <CartRowSkeleton />
        <CartRowSkeleton />
      </Stack>
      <Stack p={4} pt={0} gap={2}>
        <Skeleton h="48px" rounded={12} w="full" />
      </Stack>
    </>
  );
}
